module.exports = __webpack_public_path__ + "img/logo-preto-drogasil.773b7da8.svg";